import { render, staticRenderFns } from "./AdditionalFeaturesMenu.vue?vue&type=template&id=246e4ed2&scoped=true&"
import script from "./AdditionalFeaturesMenu.vue?vue&type=script&lang=js&"
export * from "./AdditionalFeaturesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246e4ed2",
  null
  
)

export default component.exports